module.exports = __webpack_public_path__ + "img/mo.b759f9c2.svg";